var styles = {
  "radio": {
    "display": "block",
    "fontSize": "0.9375rem",
    "lineHeight": "1.375rem",
    "paddingLeft": "1.375rem",
    "position": "relative",
    "WebkitAppearance": "none",
    "&:not(:last-child)": {
      "marginBottom": "1.25rem"
    }
  },
  "radio_input_type_radio": {
    "left": "0",
    "position": "absolute",
    "opacity": "0",
    "&:hover + label": {
      "color": "inherit"
    },
    "&:hover + label::before": {
      "backgroundColor": "#fff",
      "borderColor": "#006fcf"
    },
    "&:hover + label::after": {
      "backgroundColor": "#006fcf"
    },
    "&:focus + label::before": {
      "outline": "dashed 1px #53565a",
      "outlineOffset": "3px",
      "borderColor": "#006fcf"
    },
    "&:checked + label": {
      "color": "inherit"
    },
    "&:checked + label::before": {
      "backgroundColor": "#fff",
      "borderColor": "#006fcf"
    },
    "&:checked + label::after": {
      "backgroundColor": "#006fcf",
      "opacity": "1 !important",
      "transform": "scale(1) !important"
    },
    "&:disabled + label": {
      "color": "#97999b",
      "cursor": "not-allowed"
    },
    "&:disabled + label::before": {
      "backgroundColor": "rgba(0, 0, 0, 0.05)",
      "borderColor": "#c8c9c7",
      "cursor": "not-allowed"
    },
    "&:disabled + label::after": {
      "backgroundColor": "rgba(0, 0, 0, 0.3)"
    }
  },
  "radio_input_type_radio__aria_invalid_true": {
    "&:checked + label::before": {
      "backgroundColor": "#fff",
      "borderColor": "#b42c01",
      "cursor": "not-allowed"
    },
    "&:checked + label::after": {
      "backgroundColor": "#fff",
      "cursor": "not-allowed"
    }
  },
  "radio_label": {
    "paddingLeft": "0.625rem",
    "fontFamily": "\"Helvetica Neue\", Helvetica, sans-serif",
    "fontSize": "1rem",
    "color": "inherit",
    "cursor": "pointer",
    "display": "inline-block",
    "fontWeight": "normal",
    "lineHeight": "1.375rem",
    "marginBottom": "0",
    "minHeight": "1.375rem",
    "position": "relative",
    "textTransform": "inherit",
    "verticalAlign": "middle",
    "&::before": {
      "backgroundColor": "#fff",
      "border": "0.0625rem solid #97999b",
      "borderRadius": "50%",
      "content": "\"\"",
      "display": "inline-block",
      "height": "1.375rem",
      "left": "0",
      "marginLeft": "-1.375rem",
      "position": "absolute",
      "transition": "border 0.25S ease-out",
      "width": "1.375rem",
      "willChange": "border"
    },
    "&::after": {
      "backgroundColor": "#006fcf",
      "borderRadius": "50%",
      "content": "\"\"",
      "display": "inline-block",
      "height": "0.875rem",
      "left": "0.25rem",
      "marginLeft": "-1.375rem",
      "position": "absolute",
      "top": "0.25rem",
      "transform": "scale(0)",
      "transition": "transform 0.25S ease-out, opacity 0.25S ease-out",
      "width": "0.875rem",
      "willChange": "transform, opacity"
    }
  },
  "radioAlignMiddle_label": {
    "&::before": {
      "top": "calc(50% - 11px)"
    },
    "&::after": {
      "top": "calc(50% - 7px)"
    }
  }
};

export default styles;
